export default __webpack_public_path__ + "static/media/logo-kitjornal.8d237e56.svg";